/*
 * Pause control for the claim ticker.
 *
 * The strip is a CSS animation and keeps working with this file absent. All
 * this does is reveal the button the section ships hidden and toggle a
 * data-paused attribute on the strip, which peanut.css turns into
 * animation-play-state: paused. Play resumes from the frame it stopped on.
 * The label says what a press will do, so there is no aria-pressed as well:
 * a changing name and a pressed state together read as a contradiction.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-peanut-ticker-toggle]').forEach(function (button) {
    var strip = button.closest('.peanut-ticker');
    var label = button.querySelector('span');
    if (!strip || !label) return;

    button.hidden = false;

    button.addEventListener('click', function () {
      var paused = strip.toggleAttribute('data-paused');
      label.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    });
  });
})();
